import { gql } from "@apollo/client";

export const customerStatisticsFragment = gql`
  fragment CustomerStatistics on CustomerStatisticsEntry {
    id
    expectedVolume
    statVolume12Months
    unitCategoryCode
    expectedStatVolume
    sailingCategoryCode
    volume12Months
    actualOutcomeInPercent
  }
`;
